import React, {PropsWithChildren, memo} from 'react';
import FloatAIJump from '../views/AViewComponents/FloatAIJump';
import {selectUserInfo} from '../store/user';
import {useAppSelector} from '../store/hooks';

interface FloatAIBaoProps {
  currentRouteName: string | undefined;
  children: React.ReactNode;
}

const HIDE_FLOAT_AI_JUMP_ROUTES = [
  // 'ChatGPTAssist',
  'Login',
  'Register',
  'ForgetPassword',
  'UseCDK',
  'FuWuDocument',
  // 添加其他需要隐藏 FloatAIJump 的路由名称
];
const HIDE_FLOAT_AIJUMP_LEFT_BUTTON_ROUTES = ['ChatGPTTeacher'];
const FloatAIBao = memo(function FloatAIBao({
  children,
  currentRouteName,
}: PropsWithChildren<FloatAIBaoProps>): React.JSX.Element {
  console.log('currentRouteName', currentRouteName);
  const userInfo = useAppSelector(selectUserInfo);
  const grade = userInfo?.curriculumSetup?.xkwGradeId;
  const showFloatAIJump =
    currentRouteName && !HIDE_FLOAT_AI_JUMP_ROUTES.includes(currentRouteName);

  return (
    <>
      {children}
      {showFloatAIJump && (
        <FloatAIJump
          showLeftButton={
            currentRouteName === 'ChatGPTAssist'
              ? grade > 6
              : !HIDE_FLOAT_AIJUMP_LEFT_BUTTON_ROUTES.includes(currentRouteName)
          }
        />
      )}
    </>
  );
});

export default FloatAIBao;
